export enum BannerDisplayMode {
  FULL_SCREEN = 'full_screen',
  FIT_CONTENT = 'fit_content',
}
